import styled from 'styled-components';
import { baseTheme } from '../../../../global/styles/theme';

export const IssuingWithoutBasketContentContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 16px;
`;

export const IssuingWithoutBasketContainer = styled('div')`
  height: 40px;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

export const IssuingWithoutBasketButton = styled('button')<{
  clicked: boolean;
}>`
  background-color: transparent;
  padding: 10px;
  border: none;
  border-radius: 10px;
  box-shadow: 0 2px 10px ${baseTheme.colors.mainBlue};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${baseTheme.colors.mainBlue};
  font-size: 18px;
  &:hover {
    cursor: pointer;
    padding: ${({ clicked }) => (clicked ? '10px' : '8px')};
  }
`;

export const IssuingWithoutBasketStatus = styled('div')<{ status: string }>`
  margin-left: 10px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${({ status }) => {
    if (status === 'success') return baseTheme.colors.focusLight;
    if (status === 'warning') return baseTheme.colors.warning;
    return baseTheme.colors.error;
  }};
  font-size: 18px;
`;

export const IssuingWithoutBasketModal = styled('div')`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 16px;
  border-radius: 12px;
  background: #fff;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const IssuingWithoutBasketStatusBtn = styled('button')`
  background-color: transparent;
  padding: 10px;
  border: none;
  border-radius: 10px;
  box-shadow: 0 2px 10px ${baseTheme.colors.mainBlue};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${baseTheme.colors.mainBlue};
  font-size: 18px;
  margin-left: 10px;
  &:hover {
    cursor: pointer;
    padding: 8px;
  }
`;

export const IssuingWithoutBasketTable = styled('table')`
  width: 100%;
  border-collapse: collapse;
  min-width: 560px;
  margin-top: 16px;
`;

export const IssuingWithoutBasketTableRow = styled('tr')`
  border-bottom: 1px solid ${baseTheme.colors.disabled};
  display: flex;
  justify-content: flex-start;
`;

export const IssuingWithoutBasketTableTd = styled('td')`
  padding: 12px 16px;
  font-size: 14px;
  color: ${baseTheme.colors.primary};
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${baseTheme.colors.disabled};
  & p {
    margin: 0;
    text-align: left;
  }
  .header-text {
    font-weight: 500;
  }
`;

export const StandartStatus = styled('div')<{ error: boolean }>`
  font-size: 14px;
  color: ${({ error }) => (error ? '#ef4444' : '#059669')};
  font-weight: 500;
  text-align: center;
  padding: 12px 16px;
  background: ${({ error }) => (error ? '#fef2f2' : '#ecfdf5')};
  border: 1px solid ${({ error }) => (error ? '#fecaca' : '#a7f3d0')};
  border-radius: 8px;
  width: 100%;
`;

export const QrContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
`;

export const BlockHint = styled('p')`
  margin: 0 0 20px 0;
  font-size: 14px;
  color: #6b7280;
  line-height: 1.5;
`;

export const QrPreviewButton = styled('button')`
  border: 2px solid #e0e4ea;
  border-radius: 12px;
  padding: 8px;
  background: #ffffff;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #3b5bdb;
    box-shadow: 0 4px 12px rgba(59, 91, 219, 0.15);
  }

  & img {
    display: block;
  }
`;

export const QrModalContent = styled('div')`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ffffff;
  border-radius: 16px;
  padding: 32px;
  outline: none;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const QrBig = styled('img')`
  width: 320px;
  height: 320px;
  display: block;
`;
